<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>
    <b-table striped hover small responsive id="tablereport"
      :items="payments"
      :fields="paymentsFields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"
      :totalRows="totalRows"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accounting_period_id: 0
      },
      userList: [],
      currencies: [],
      methods: [],
      payments: [],
      paymentsFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'external_id', label: this.$i18n.t('External account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'actual_date', label: this.$i18n.t('Actual payment time'), sortable: true},
        {key: 'payment_enter_date', label: this.$i18n.t('Time of payment'), sortable: true},
        {key: 'payment', label: this.$i18n.t('Volume'), sortable: true},
        {key: 'payment_incurrency', label: this.$i18n.t('Amount (in currency)'), sortable: true},
        {key: 'currency_id', label: this.$i18n.t('Currency'), sortable: true},
        {key: 'method', label: this.$i18n.t('Payment method'), sortable: true},
        {key: 'username', label: this.$i18n.t('Recieved by'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'payment_ext_number', label: this.$i18n.t('Payment document'), sortable: true},
        {key: 'burnt_date', label: this.$i18n.t('Expiration date'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      filterOptions: {
        isFilterGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async load () {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      var numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_PAYMENTS', this.getStore).then(response => {
        this.payments = this.$store.getters['Reports/PAYMENTS']
        this.userList = this.$store.getters['Users/SYSTEM_USERS_SHORT_DATA']
        this.currencies = this.$store.getters['ReferenceBooks/CURRENCIES']
        this.methods = this.$store.getters['ReferenceBooks/PAYMENT_METHODS']
        for (let i in this.payments) {
          for (let j in this.userList) {
            var curUser = this.userList[j]
            if (curUser.user_id === this.payments[i].user_id) {
              this.payments[i].username = this.userList[j].login
              break
            }
          }
          for (let j in this.currencies) {
            var newCurr = this.currencies[j]
            if (newCurr.currency_id === this.payments[i].currency_id) {
              this.payments[i].currency_id = this.currencies[j].currency_brief_name
              break
            }
          }
          for (let i in this.payments) {
            for (let j in this.methods) {
              var newMeth = this.methods[j]
              if (newMeth.id === this.payments[i].method) {
                this.payments[i].method = this.methods[j].name
                break
              }
            }
          }
          this.payments[i].actual_date = moment(Number(this.payments[i].actual_date) * 1000).format('DD-MM-YYYY hh:mm')
          this.payments[i].payment_enter_date = moment(Number(this.payments[i].payment_enter_date) * 1000).format('DD-MM-YYYY hh:mm')
          if (this.payments[i].burnt_date) {
            this.payments[i].burnt_date = moment(Number(this.payments[i].burnt_date) * 1000).format('DD-MM-YYYY hh:mm')
          } else {
            this.payments[i].burnt_date = this.$i18n.t('Not defined')
          }
          this.payments[i].username = this.payments[i].username + '(' + this.payments[i].user_id + ')'
        }
        this.loadDone()
      })
      this.totalRows = this.payments.length
      this.$emit('input', this.totalRows)
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.$store.dispatch('ReferenceBooks/GET_PAYMENT_METHODS')
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
    this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/payments/main.vue